import type { GraphElements } from '@/shared/ui/graph-renderer/contract';
import type { TQLGraphResponse } from '../model/graph';

/** Graph-renderer input shared by SRM canvases and dashboard graph widgets. */
export const getTQLGraphElements = (
  graph: TQLGraphResponse | null | undefined,
): GraphElements => ({
  nodes: graph?.nodes?.map((node) => ({ data: { ...node } })) ?? [],
  edges:
    graph?.links?.map((edge) => ({
      data: { ...edge, source: edge.src_ci_id, target: edge.dst_ci_id },
    })) ?? [],
});